import { SharingAdapter } from '@components/common/Sharing';
import React from 'react';
import { useGetShare } from './atom';
import { get } from 'lodash';

// TODO: implementate save mutation for share
// to eventually remove the saga layer

function Share({ config, ...rest }) {
  const pageKey = get(config, ['page', 'key'], null);
  const { shareData } = useGetShare({ pageKey });
  const { url } = config;

  return (
    <SharingAdapter
      url={url}
      config={shareData}
      {...rest}
    />
  )
}

export default Share;
